import { createGenerateClassName } from '@mui/styles'

function generateClassName() {
  return createGenerateClassName({ productionPrefix: 'c' })
}

export default generateClassName
